import React from 'react';
import moment from 'moment';
import RemoveTimesheetDetailButton from './RemoveTimesheetDetailButton';
import TimesheetDetailPhaseSelect from './TimesheetDetailPhaseSelect';
import { calculateTimesheetDetailElapsedHours } from './DailyTimesheet';
import ConstrainedTimeInput from '../common/forms/ConstrainedTimeInput';

const formatTime = (value) => {
    const parsed = moment(value, ['HH:mm', 'H:mm'], true);

    return parsed.isValid() ? parsed.format('h:mm A') : '';
};

export default class DailyTimesheetDetail extends React.Component {
    onStartTimeChange = (e) => {
        const {
            dailyTimesheetDetail,
            dailyTimesheet,
            onDailyTimesheetMutated,
        } = this.props;

        dailyTimesheetDetail.startTime = e.target.value;

        dailyTimesheetDetail.hoursSpent = calculateTimesheetDetailElapsedHours(
            dailyTimesheet,
            dailyTimesheetDetail
        );

        onDailyTimesheetMutated(dailyTimesheet);
    };

    onEndTimeChange = (e) => {
        const {
            dailyTimesheetDetail,
            dailyTimesheet,
            onDailyTimesheetMutated,
        } = this.props;

        dailyTimesheetDetail.endTime = e.target.value;

        dailyTimesheetDetail.hoursSpent = calculateTimesheetDetailElapsedHours(
            dailyTimesheet,
            dailyTimesheetDetail
        );

        onDailyTimesheetMutated(dailyTimesheet);
    };

    render() {
        const { dailyTimesheet, dailyTimesheetDetail, contracts, readOnly } =
            this.props;

        const contract = contracts.find(
            (c) => c.id == dailyTimesheetDetail.contractId
        );

        return (
            <tr className="daily-timesheet-detail">
                <td className="align-middle">
                    {contract.companyName} - {contract.number}
                </td>
                <td className="align-middle">
                    <TimesheetDetailPhaseSelect
                        {...this.props}
                        contract={contract}
                    />
                </td>
                <td className="align-middle">
                    {readOnly ? (
                        formatTime(dailyTimesheetDetail.startTime)
                    ) : (
                        <ConstrainedTimeInput
                            value={dailyTimesheetDetail.startTime}
                            onChange={this.onStartTimeChange}
                        />
                    )}
                </td>
                <td className="align-middle">
                    {readOnly ? (
                        formatTime(dailyTimesheetDetail.endTime)
                    ) : (
                        <ConstrainedTimeInput
                            value={dailyTimesheetDetail.endTime}
                            onChange={this.onEndTimeChange}
                        />
                    )}
                </td>
                <td className="align-middle">
                    {calculateTimesheetDetailElapsedHours(
                        dailyTimesheet,
                        dailyTimesheetDetail
                    )}
                </td>
                <td className="align-middle">
                    <RemoveTimesheetDetailButton {...this.props} />
                </td>
            </tr>
        );
    }
}
